<template>
    <v-tooltip :text="badge.label" location="end">
        <template #activator="{props}">
            <v-chip v-bind="props" :aria-label="badge.label" :color="menuCountColor(badge.severity)"
                    class="ml-1 menu-count-chip" size="x-small" variant="flat"
                    :link="!!badge.to" @click="onClick">
                {{ badge.count > 99 ? '99+' : badge.count }}
            </v-chip>
        </template>
    </v-tooltip>
</template>

<script setup>
import {menuCountColor} from "@/composables/useMenuCounts";

const props = defineProps({
    // {count, severity, label, to}
    badge: {type: Object, required: true},
});
const emit = defineEmits(['open']);

const onClick = (event) => {
    if (!props.badge.to) return;
    event.stopPropagation();
    emit('open', props.badge);
};
</script>
